<div class="recover-password-holder">
    <serviceos-ng-local-loader [showLoader]="showLocalLoader"></serviceos-ng-local-loader>
    <div class="title-holder" *ngIf="!emailSent">
        <h2 *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">{{ moduleAuthTexts.recover_title ? moduleAuthTexts.recover_title : 'Reset your password.'}}</h2>
        <serviceos-ng-alert class="error-alert" *ngIf="formErrorMessage" [type]="'error'">
            {{ formErrorMessage }}
        </serviceos-ng-alert>
        <serviceos-ng-alert class="error-alert" *ngIf="!isRepeatPasswordMatch" [type]="'error'">
            <ng-container *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">
                {{ moduleAuthTexts.passwords_do_not_match_error ? moduleAuthTexts.passwords_do_not_match_error : 'The passwords do not match!' }}
            </ng-container>
        </serviceos-ng-alert>
    </div>
    <form
        [formGroup]="recoverPasswordForm"
        (ngSubmit)="processForm()"
        #recoverPasswordFormTemplate="ngForm"
        *ngIf="!emailSent; else confirmationMessageBox"
    >
        <div class="obf-form-part">
            <div class="input-holder">
                <serviceos-ng-form-field>
                    <serviceos-ng-label *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">{{ moduleAuthTexts.recover_pass_title ? moduleAuthTexts.recover_pass_title : 'Please enter your password' }}</serviceos-ng-label>
                    <input
                        [serviceosNgInput]="password?.value"
                        [error]="
                        password?.invalid && recoverPasswordFormTemplate.submitted
                        "
                        type="password"
                        id="password"
                        name="password"
                        formControlName="password"
                    />
                    <serviceos-ng-error-message *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">{{ moduleAuthTexts.recover_pass_error ? moduleAuthTexts.recover_pass_error : 'Please enter a valid password' }}</serviceos-ng-error-message>
                </serviceos-ng-form-field>
            </div>
            <div class="input-holder">
                <serviceos-ng-form-field>
                    <serviceos-ng-label *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">{{ moduleAuthTexts.recover_repeat_pass_title ? moduleAuthTexts.recover_repeat_pass_title : 'Repeat your password' }}</serviceos-ng-label>
                    <input
                        [serviceosNgInput]="repeat_password?.value"
                        [error]="
                        repeat_password?.invalid && recoverPasswordFormTemplate.submitted
                        "
                        type="password"
                        id="repeat_password"
                        name="repeat_password"
                        formControlName="repeat_password"
                    />
                    <serviceos-ng-error-message *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">{{ moduleAuthTexts.recover_repeat_pass_error ? moduleAuthTexts.recover_repeat_pass_error : 'Please enter a valid password' }}</serviceos-ng-error-message>
                </serviceos-ng-form-field>
            </div>

            <div>
                <serviceos-ng-button
                    [isSubmitButton]="true"
                    [type]="'primary'"
                    [isFullWidth]="true"
                    *ngIf="moduleAuthTexts$ | async as moduleAuthTexts"
                    >
                    {{ moduleAuthTexts.recover_button_title ? moduleAuthTexts.recover_button_title : 'Reset password' }}
                </serviceos-ng-button>
            </div>
        </div>
    </form>

    <ng-template #confirmationMessageBox>
        <h2 style="text-align: center" *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">
            {{ moduleAuthTexts.recover_confirm_title ? moduleAuthTexts.recover_confirm_title : 'Thank you for reseting password !!!' }}
        </h2>
        <p style="text-align: center" *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">{{ moduleAuthTexts.recover_confirm_message ? moduleAuthTexts.recover_confirm_message : 'You can go into your account by clicking the button below.' }}</p>
        <serviceos-ng-button
            *ngIf="moduleAuthTexts$ | async as moduleAuthTexts"
            [type]="'secondary'"
            [isFullWidth]="true"
            (click)="changeScreenHandler('../login')">
            {{ moduleAuthTexts.recover_back_button ? moduleAuthTexts.recover_back_button : 'Go to your account!' }}
        </serviceos-ng-button>
    </ng-template>
</div>
